import useSWR from "swr";
import { z } from "zod";
import { Network } from "@/utils/network";
import { zodUnsafeValidate } from "@/utils/zod";
import { InstagramSearch } from "../types";
import { useInstagramSearch } from "./useInstagramSearch";

const InstagramSearchCountriesResponseSchema = z.object({
  countries: InstagramSearch.OptionSchema.array(),
});

type InstagramSearchCountriesResponse = z.infer<
  typeof InstagramSearchCountriesResponseSchema
>;

export const useInstagramSearchCountries = (query: string) => {
  const config = useInstagramSearch((state) => state.config);

  return useSWR(
    [config.api.getCountries, query],
    async ([api, query]) => {
      const { data } = await Network.get<InstagramSearchCountriesResponse>(
        api,
        {
          query,
        },
      );

      return zodUnsafeValidate(InstagramSearchCountriesResponseSchema, data);
    },
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnMount: true,
      revalidateOnReconnect: true,
      shouldRetryOnError: false,
      keepPreviousData: true,
    },
  );
};
